import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../api/tenantApi';
import { useToast, errText, useConfirm, useCaptchaConfirm } from './ui';

export default function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const [confirmLogout, logoutConfirmNode] = useConfirm();
  const [confirmRevoke, revokeConfirmNode] = useCaptchaConfirm();

  const clientCode = sessionStorage.getItem('clientCode') || 'UNKNOWN';
  const role = sessionStorage.getItem('userRole') || 'UNKNOWN';

  const handleLogout = async () => {
    const ok = await confirmLogout('Log out of the tenant control panel? You will need to sign in again.');
    if (!ok) return;
    // Clears the full shared session — same keys every other panel reads —
    // since this is the same login as Student/Teacher/Parent/etc.
    sessionStorage.clear();
    navigate('/');
  };

  const handleRevokeOthers = async () => {
    const ok = await confirmRevoke('Revoke all other active sessions for this client? Any other signed-in device or browser will be logged out immediately.');
    if (!ok) return;
    setBusy(true);
    try {
      const refreshToken = sessionStorage.getItem('refreshToken');
      await auth.revokeOtherSessions(clientCode, refreshToken);
      toast.success('All other active sessions for this client were revoked.');
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <header className="root-topbar">
      {logoutConfirmNode}
      {revokeConfirmNode}
      <div className="root-topbar__path">
        root@waralsadmin<b>:{location.pathname}</b>#
      </div>
      <div className="root-topbar__right">
        {/* <span><span className="status-dot" />SESSION ACTIVE</span> */}
        <span>CLIENT: <b style={{ color: 'var(--green)' }}>{clientCode}</b></span>
        <span>ROLE: <b style={{ color: 'var(--green)' }}>WaralsAdmin</b></span>
        <button className="term-btn term-btn--sm term-btn--ghost" disabled={busy} onClick={handleRevokeOthers}>
          revoke_other_sessions
        </button>
        <button className="term-btn term-btn--sm term-btn--danger" onClick={handleLogout}>
          logout
        </button>
      </div>
    </header>
  );
}